import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, GraduationCap, MessageSquare } from 'lucide-react';
import { ASSISTANT_NAME } from '../../constants/branding';

const BootcampLanding: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="p-4 sm:p-6 overflow-auto h-full">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-warm-white mb-2">
            Bootcamp
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Learn Agent Commander through documentation, tutorials, and AI-powered assistance.
          </p>
        </div>

        {/* Navigation Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <button
            onClick={() => navigate('/bootcamp/documentation')}
            className="bg-white dark:bg-cap-dark p-6 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md hover:border-primary-300 dark:hover:border-primary-600 transition-all text-left"
          >
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                <BookOpen className="w-6 h-6 text-primary-600 dark:text-primary-400" />
              </div>
              <h3 className="ml-3 text-lg font-semibold text-gray-900 dark:text-warm-white">Documentation</h3>
            </div>
            <p className="text-gray-600 dark:text-gray-400">
              Browse reference material, feature guides, and API documentation for Agent Commander.
            </p>
          </button>

          <button
            onClick={() => navigate('/bootcamp/tutorials')}
            className="bg-white dark:bg-cap-dark p-6 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md hover:border-green-300 dark:hover:border-green-600 transition-all text-left"
          >
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-green-100 dark:bg-green-900/30 rounded-lg flex items-center justify-center">
                <GraduationCap className="w-6 h-6 text-green-600 dark:text-green-400" />
              </div>
              <h3 className="ml-3 text-lg font-semibold text-gray-900 dark:text-warm-white">Tutorials</h3>
            </div>
            <p className="text-gray-600 dark:text-gray-400">
              Get step-by-step guidance on using Agent Commander. Learn about agents, workflows, and best practices.
            </p>
          </button>

          <button
            onClick={() => navigate('/bootcamp/assistant')}
            className="bg-white dark:bg-cap-dark p-6 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md hover:border-purple-300 dark:hover:border-purple-600 transition-all text-left"
          >
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-purple-100 dark:bg-purple-900/30 rounded-lg flex items-center justify-center">
                <MessageSquare className="w-6 h-6 text-purple-600 dark:text-purple-400" />
              </div>
              <h3 className="ml-3 text-lg font-semibold text-gray-900 dark:text-warm-white">{ASSISTANT_NAME}</h3>
            </div>
            <p className="text-gray-600 dark:text-gray-400">
              Chat with {ASSISTANT_NAME} to get help building workflows, debugging issues, and optimizing workflows.
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BootcampLanding;
